import { PhoneNumbers } from "../models/phone-numbers.model";

export class PhonNumberHelper {
  public static sanitiseEmptyPhoneNumbers (phones: PhoneNumbers[]): PhoneNumbers[] {
    phones = phones.filter(p => p.Type !== '' || p.Number !== '' || p.Preferred);
    // if all rows are empty return the initial default row
    return phones.length !== 0 ? phones : [new PhoneNumbers('', '', true)];
  }
}